import React, { useEffect, useState } from "react"; 
import { getContact } from "../../../services";
import CustomizedDialogs from "./CustomizedDialogs";
import RegistrationForm from "./RegistrationForm";
import { Grid, TextField } from "@material-ui/core";
import CustomizedDialogsUpdate from "./CustomizedDialogsUpdate";
import UpdateForm from "./UpdateForm";

export default function Contact({ children, title }) {
  const [Data, setData] = useState([]);
  const [id1, setId1] = React.useState([]);
  const [dataId, setDataId] = useState([]);
  const [dataLink, setDataLink] = useState([]);
  const [dataIcon, setDataIcon] = useState([]);
  const [dataIDID, setDataIDID] = useState([]);
  useEffect(() => {
    getContact().then((res) => {
      if (res.data !== null) {
        setData(res.data);
        setDataId(res.data.map((n)=>({
          ...dataId,
          ["p"]: { id: n.id, link_name: n.link_name },
        })))
        setDataLink(res.data.map((n)=>({
          ...dataId,
          ["p"]: { id: n.id, link: n.link },
        })))
        setDataIcon(res.data.map((n)=>({
          ...dataId,
          ["p"]: { id: n.id, icon: n.icon },
        })))
      
        setDataIDID(res.data.map((n)=>({
          ...dataId,
          ["p"]: { id: n.id, link: n.link },
        })))
      }
    
    });
  }, []);

  return (
    <div className="main-div">
      <div>
        <CustomizedDialogs>
          <RegistrationForm />
        </CustomizedDialogs>
      </div>
      <h3 className="titlepage">تعديل روابط الدعم الفني</h3>
      <form class="form-group">
        <Grid container maxWidth="md" spacing={2}>
          {Data.map((n) => {
            return (
              <>
                <Grid
                  container
                  maxWidth="sm"
                  spacing={4}
                  className="social-grid"
                >
                  <Grid item xs={2}>
                    <div className="div-icon">
                      <img src={n.icon} alt="img" className="icon-img" />
                      <h3 className="title-icon">{n.link_name}</h3>
                    </div>
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="الرابط"
                      type="text"
                      className="form-control"
                      required
                      enableClickToCopy
                      value={n.link}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <div>
                      <CustomizedDialogsUpdate >
                        <UpdateForm 
                        itemid={n.id}
                        id1={id1}
                        dataId={dataId}
                        dataLink={dataLink}
                        dataIcon={dataIcon}
                        dataIDID={dataIDID}

                        
                        />
                      </CustomizedDialogsUpdate>
                    </div>
                  </Grid>
                </Grid>
              </>
            );
          })}
        </Grid>
      </form>
    </div>
  );
}
